import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizeHashRouterUrl } from './normalizeHashRouterUrl';

export const NormalizeHashRouterUrlComponent = () => {
    const location = useLocation();

    useEffect(() => {
        normalizeHashRouterUrl(location);
    }, [location.pathname, location.hash, location.search, location]);

    return null;
};
